<template lang="pug">
  .container-settle-list.container-padding
    c-header
      template(slot="left")
        h3 结算账户管理
        h6 说明：当收款账户有资金收入时，商家可以为收款账户绑定结算账户，以完成资金的结算。目前有两种结算方式，资金结算到商家绑定的银行卡中，或者资金结算到商家绑定的富力钱包中。
      template(slot="right")
        div(style="min-width:260px;text-align:right")
          el-button(type="primary", @click="showCreateWallet",v-if="mchDetail.settle_type === 3 && mchDetail.type == 1") 新增钱包
          el-button(type="primary", @click="showCreate") 添加银行卡
    c-box.settle-card-container(v-loading="listLoading", :element-loading-fullscreen="false")
      div
      template(v-if="list.length !==0")
        el-card.settle-card(v-for="p,idx in list", :key="idx", shadow="hover")
          template(v-if="p.settle_type < 3")
            .settle-card-title(slot="header") 银行账户-{{ p.card.bank_name }}
            .settle-card-content 账号: {{ p.card.bank_account }}
            hr
            .settle-card-options
              .settle-card-status
                template(v-if="p.settle_type === 3 && p.card.status === 1 ") {{ p.bound_bank_card | bound_bank_card }}
                template(v-else) {{ p.card.status | acccountStatus }}
              .settle-card-detail(@click="showDetail(p.settle_type, p.ref_id, p.id,p.bind_status,p.id)", v-if="((p.settle_type !== 3 || p.bound_bank_card === 1) && mch_type === 2) || mch_type === 1")
                span 详情
                fa-icon.blue(:icon="['fa', 'arrow-alt-circle-right']")
              .settle-card-detail(@click="showBindWallet()", v-else)
                span 绑定
                fa-icon(:icon="['fa', 'link']")
          template(v-else)
            template(v-if='p.settle_type === 3')
              .settle-card-title(slot="header") 富力钱包-{{ p.wallet.title }}
              .settle-card-content 账号: {{ p.wallet.id }}
              hr
              .settle-card-options
                .settle-card-status
                  span(v-if="p.tunnel.status === 3") {{p.tunnel.is_sign_contact === 2? '已激活' : '待激活'}}
                  span(v-if="p.tunnel.status === 4") 审核失败
                  span(v-if="p.tunnel.status === 1 || p.tunnel.status === 2") 待审核
                .settle-card-detail(@click="showWalletOrMchDetail(p.tunnel.status, {wallet_id:p.wallet.id,is_sign_contact:p.tunnel.is_sign_contact,settle_id:p.id}, p.mch_draft)")
                  span 详情
                  fa-icon.blue(:icon="['fa', 'arrow-alt-circle-right']")
            template(v-if='p.settle_type === 4')
              .settle-card-title(slot="header") 富力钱包-{{ p.mch_draft.mch_name }}
              .settle-card-content 账号: {{ p.mch_draft.id }}
              hr
              .settle-card-options
                .settle-card-status
                  span(v-if="p.mch_draft.status === 2") 审批中
                  span(v-if="p.mch_draft.status === 4") 审批失败
                  span(v-if="p.mch_draft.status === 5") 用户撤回
                .settle-card-detail(@click="showMchDetail(p.mch_draft)")
                  span 详情
                  fa-icon.blue(:icon="['fa', 'arrow-alt-circle-right']")
        el-card.settle-card(v-if="mchDetail.enable_wallet_settle ===1 && !hasWallet")
            .settle-card-title(slot="header") 富力钱包
            .settle-card-content 账号: 未绑定
            hr
            .settle-card-options
              .settle-card-status
                span 未绑定
              .settle-card-detail(@click="showWalletDetail({})")
                span 详情
                fa-icon.blue(:icon="['fa', 'arrow-alt-circle-right']")
      template(v-else)
        el-card.settle-card(v-if="mchDetail.enable_wallet_settle ===1")
            .settle-card-title(slot="header") 富力钱包
            .settle-card-content 账号: 未绑定
            hr
            .settle-card-options
              .settle-card-status
                span 未绑定
              .settle-card-detail(@click="showWalletDetail({})")
                span 详情
                fa-icon.blue(:icon="['fa', 'arrow-alt-circle-right']")
        .align-center(style="width:100%",v-else) 暂无数据
    .container-pagination
      el-pagination(layout="sizes, prev, pager, next, total",
        :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
        @size-change="changeListSize", @current-change="getList")

    el-dialog(title="添加银行卡", :visible.sync="createAccount.show")
      el-form(:model="createAccount", label-position="right", label-width="125px")
        el-form-item(label="开户名") {{ createAccount.mch_name }}
        el-form-item(label="开户银行", required)
          el-select(v-model="createAccount.class_code", @change="setBankClass")
            el-option(:value="null", label="未选择")
            el-option(v-for="b in createAccount.bankClassList", :key="b.class_code", :value="b.class_code", :label="b.class_name")
        el-form-item(label="区域", required)
          el-select(v-model="createAccount.area_code", @change="setBankArea")
            el-option(:value="null", label="未选择")
            el-option(v-for="b in createAccount.bankAreaList", :key="b.area_code", :value="b.area_code", :label="b.province_name + b.city_name")
        el-form-item(label="支行", required)
          el-select(v-model="createAccount.source.bank_code")
            el-option(:value="null", label="未选择")
            el-option(v-for="b in createAccount.bankList", :key="b.bank_code", :value="b.bank_code", :label="b.bank_name")
        el-form-item(label="对公账户账号（银行卡号）", required)
          el-input(v-model="createAccount.source.bank_account")
        .txt-tip-warn(style="margin-left:125px;position: relative;top: -26px;") 提示：如果是企业商家，请填写对公账户账号，如果是个人商家，请填写银行卡号
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreate()") 保存
        el-button(@click="hideCreate()") 取消

    el-dialog(title="新增钱包", :visible.sync="createWallet.show")
      el-form(:model="mchDetail", label-position="right", label-width="200px")
        template(v-if="mchDetail.type === 1")
          h4 基本信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户类型") 公司
              el-form-item(label="公司名称") {{ mchDetail.mch_name || '未填写' }}
              template(v-if="mchDetail.uni_credit")
                el-form-item(label="统一社会信用代码或注册号") {{ mchDetail.uni_credit ||'未填写' }}
              template(v-else)
                el-form-item(label="营业执照号") {{ mchDetail.business_license ||'未填写' }}
                el-form-item(label="组织机构代码") {{ mchDetail.organization_code ||'未填写' }}
                el-form-item(label="税务登记证件号") {{ mchDetail.tex_registration_no ||'未填写' }}
            el-col(:span="12")
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              template(v-if="mchDetail.uni_credit")
                el-form-item(label="营业执照类型") 三证合一，一证一码
              template(v-else)
                el-form-item(label="营业执照类型") 一证三码，三码独立
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image",
                    @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
          h4 法人信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="法人姓名") {{ mchDetail.legal_per_name || '未填写' }}
              el-form-item(label="法人证件号") {{ mchDetail.legal_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="法人手机号") {{ mchDetail.legal_per_telephone_no || '未填写' | desensitization }}
            el-col(:span="12")
              el-form-item(label="法人证件类型") {{ mchDetail.legal_per_id_type | resp_per_id_type }}
              el-form-item(label="身份证照片")
                el-row(:gutter="10")
                  el-col(:span="12")
                    img(v-if="mchDetail.legal_per_id_positive", :src="mchDetail.legal_per_id_positive | image",
                        @click="$zoom($options.filters.image(mchDetail.legal_per_id_positive))").mch-image
                    template(v-else) 未提交
                  el-col(:span="12")
                    img(v-if="mchDetail.legal_per_id_opposite", :src="mchDetail.legal_per_id_opposite | image",
                        @click="$zoom($options.filters.image(mchDetail.legal_per_id_opposite))").mch-image
                    template(v-else) 未提交
          h4 责任人信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="责任人姓名") {{ mchDetail.resp_per_name || '未填写' }}
              el-form-item(label="责任人证件号") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
            el-col(:span="12")
              el-form-item(label="责任人证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}


          hr
          h4 公司联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户电话") {{ mchDetail.tel || '未填写' }}
            el-col(:span="12")
              el-form-item(label="公司地址") {{ mchDetail.business_address || '未填写' }}
          hr
          h4 责任人联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="绑定的手机号") {{ mchDetail.resp_per_telephone_no || '未填写'| desensitization }}
            el-col(:span="12")
              el-form-item(label="绑定的邮箱") {{ mchDetail.resp_per_email || '未填写' }}
          h4 钱包提现账号
            el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="开户名",required)
                el-input(v-model.trim="mchDetail.mch_name",disabled)
              el-form-item(label="开户银行所在地",required)
                el-select(v-model.trim="source.bankArea", @change="getBankListWallet()", clearable, filterable,value-key="area_code")
                    el-option(v-for="b in bankAreaList", :key="b.area_code", :value="b", :label="b.province_name + b.city_name")
              el-form-item(label="对公账户账号",required)
                el-input(v-model.trim="source.public_account")
            el-col(:span="12")
              el-form-item(label="开户银行",required)
                el-select(v-model.trim="source.bankClass", @change="getBankAreaListWallet()", clearable, filterable,value-key="class_code")
                    el-option(v-for="b in bankClassList", :key="b.class_code", :value="b", :label="b.class_name")
              el-form-item(label="支行名称",required)
                el-select(v-model.trim="source.bank", clearable, filterable, value-key="bank_code", @change="getBankWallet()" )
                    el-option(v-for="b in bankList", :key="b.bank_code", :value="b", :label="b.bank_name")
              el-form-item(label="对公账户证明",required)
                el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                    :show-file-list="false", :on-change="(file) => uploadChange(file, 'public_account_pic_preview', 'public_account_pic')")
                    el-button(type="primary") 选择文件
              el-form-item(label="")
                img(v-if="source.public_account_pic", :src="source.public_account_pic | image",
                    @click="$zoom($options.filters.image(source.public_account_pic))").mch-image
                img(v-else-if="source.public_account_pic_preview", :src="source.public_account_pic_preview",
                    @click="$zoom(source.public_account_pic_preview)").mch-image
                template(v-else) 未上传


        template(v-if="mchDetail.type === 2")
          //- 个人类型
          h4 基本信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户类型") 个人
              el-form-item(label="个人姓名") {{ mchDetail.resp_per_name || '未填写' }}
              el-form-item(label="证件号码") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image", @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
            el-col(:span="12")
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              el-form-item(label="证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
              el-form-item(label='') &nbsp;
              el-form-item(label="身份证照片")
                el-row(:gutter="10")
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_positive", :src="mchDetail.resp_per_id_positive | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_positive))").mch-image
                    template(v-else) 未提交
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
                    template(v-else) 未提交
          hr
          h4 个人联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="联系地址") {{ mchDetail.business_address || '未填写' }}
              el-form-item(label="手机",required) {{ mchDetail.resp_per_telephone_no || '未绑定' | desensitization}}
            el-col(:span="12")
              el-form-item(label="") &nbsp;
              el-form-item(label="") &nbsp;
              el-form-item(label="邮箱") {{ mchDetail.resp_per_email || '未绑定' }}

      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveWalletCreate()" :disabled="!source.public_account_pic") 保存
        el-button(@click="hideWalletCreate()") 取消

    el-dialog(title="绑定富力钱包", :visible.sync="bindWallet.show", v-loading="bindWallet.loading", :element-loading-fullscreen="false")
      .display-block.wallet-step-title 1、扫描二维码，注册并开通富力钱包
      .grey 如果您已在自在社区、富力好房、佣多多等APP中注册并开通了富力钱包，可直接进行第二步。
      qriously(:value="wallet_url", :size="240", :padding="20" v-if="wallet_url").align-center
      .display-block.wallet-step-title 2、输入您的富力钱包、自在社区、富力好房或佣多多的注册手机号
      el-form(:model="bindWallet", label-position="right", label-width="125px",v-if="signDisable")
        el-form-item(label="手机号码", required)
          el-input(v-model="bindWallet.mobile")
        el-form-item(label="验证码", required)
          el-input(v-model="bindWallet.verify_code",class="sms",v-if="cd<=0")
            el-button(slot="append",@click="sendVerifySMS") 获取
          el-input(v-model="bindWallet.verify_code",v-else)
            el-button(slot="append",@click="sendVerifySMS") {{cd}}秒
        .align-center
            el-button(type="primary", @click="saveBindWallet()") 登陆绑定
        //- el-button(@click="hideBindWallet()") 取消
      .login-success(v-else)
        i.el-icon-circle-check
        span 登录成功
      .display-block.wallet-step-title 3、签署委托扣款协议
      .align-center
        el-button(type="primary", @click="goSign()",:disabled="signDisable") 去签约
      .dialog-footer(slot="footer")

    el-dialog(title="钱包审核详情", :visible.sync="mchAuditDetail.show")
      el-form(:model="mchDetail", label-position="right", label-width="200px")
        h4 审核情况
          el-row(:gutter="10")
            el-col(:span="24")
              el-form-item(label="审核状态")
                  span(v-if="mchAuditDetail.mch_draft.status === 1") 待审批
                  span(v-if="mchAuditDetail.mch_draft.status === 2") 审批中
                  span(v-if="mchAuditDetail.mch_draft.status === 3") 审批通过
                  span(v-if="mchAuditDetail.mch_draft.status === 4") 审批失败
                  span(v-if="mchAuditDetail.mch_draft.status === 5") 用户撤回
            el-col(:span="24")
              el-form-item(label="说明") {{mchAuditDetail.mch_draft.audit_msg ? mchAuditDetail.mch_draft.audit_msg :"-"}}
        template(v-if="mchDetail.type === 1")
          h4 基本信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户类型") 公司
              el-form-item(label="公司名称") {{ mchDetail.mch_name || '未填写' }}
              template(v-if="mchDetail.uni_credit")
                el-form-item(label="统一社会信用代码或注册号") {{ mchDetail.uni_credit ||'未填写' }}
              template(v-else)
                el-form-item(label="营业执照号") {{ mchDetail.business_license ||'未填写' }}
                el-form-item(label="组织机构代码") {{ mchDetail.organization_code ||'未填写' }}
                el-form-item(label="税务登记证件号") {{ mchDetail.tex_registration_no ||'未填写' }}
            el-col(:span="12")
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              template(v-if="mchDetail.uni_credit")
                el-form-item(label="营业执照类型") 三证合一，一证一码
              template(v-else)
                el-form-item(label="营业执照类型") 一证三码，三码独立
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image",
                    @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
          hr
          h4 法人信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="法人姓名") {{ mchDetail.legal_per_name || '未填写' }}
              el-form-item(label="法人证件号") {{ mchDetail.legal_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="法人手机号") {{ mchDetail.legal_per_telephone_no || '未填写' | desensitization }}
            el-col(:span="12")
              el-form-item(label="法人证件类型") {{ mchDetail.legal_per_id_type | resp_per_id_type }}
              el-form-item(label="身份证照片")
                el-row(:gutter="10")
                  el-col(:span="12")
                    img(v-if="mchDetail.legal_per_id_positive", :src="mchDetail.legal_per_id_positive | image",
                        @click="$zoom($options.filters.image(mchDetail.legal_per_id_positive))").mch-image
                    template(v-else) 未提交
                  el-col(:span="12")
                    img(v-if="mchDetail.legal_per_id_opposite", :src="mchDetail.legal_per_id_opposite | image",
                        @click="$zoom($options.filters.image(mchDetail.legal_per_id_opposite))").mch-image
                    template(v-else) 未提交
          hr
          h4 责任人信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="责任人姓名") {{ mchDetail.resp_per_name || '未填写' }}
              el-form-item(label="责任人证件号") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
            el-col(:span="12")
              el-form-item(label="责任人证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
          hr
          h4 公司联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户电话") {{ mchDetail.tel || '未填写' }}
            el-col(:span="12")
              el-form-item(label="公司地址") {{ mchDetail.business_address || '未填写' }}
          hr
          h4 责任人联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="绑定的手机号") {{ mchDetail.resp_per_telephone_no || '未填写'| desensitization }}
            el-col(:span="12")
              el-form-item(label="绑定的邮箱") {{ mchDetail.resp_per_email || '未填写' }}
          hr
          h4(v-if="mchAuditDetail.mch_draft.mch_public_draft") 钱包提现账号
            el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="开户名",required) {{mchAuditDetail.mch_draft.mch_public_draft.public_account_name}}
              el-form-item(label="开户银行所在地",required) {{ mchAuditDetail.mch_draft.mch_public_draft.deposit_bank_city ? `${mchAuditDetail.mch_draft.mch_public_draft.deposit_bank_province}${mchAuditDetail.mch_draft.mch_public_draft.deposit_bank_city}`:'未填写' }}
              el-form-item(label="对公账户账号",required) {{mchAuditDetail.mch_draft.mch_public_draft.public_account}}
            el-col(:span="12")
              el-form-item(label="开户银行",required)  {{mchAuditDetail.mch_draft.mch_public_draft.deposit_bank}}
              el-form-item(label="支行名称",required)  {{mchAuditDetail.mch_draft.mch_public_draft.sub_branch_bank}}
              el-form-item(label="对公账户证明")
                img(v-if="mchAuditDetail.mch_draft.mch_public_draft.public_account_pic", :src="mchAuditDetail.mch_draft.mch_public_draft.public_account_pic | image",
                    @click="$zoom($options.filters.image(mchAuditDetail.mch_draft.mch_public_draft.public_account_pic))").mch-image
                template(v-else) 未提交


        template(v-if="mchDetail.type === 2")
          //- 个人类型
          h4 基本信息
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="商户类型") 个人
              el-form-item(label="个人姓名") {{ mchDetail.resp_per_name || '未填写' }}
              el-form-item(label="证件号码") {{ mchDetail.resp_per_id_no || '未填写' | desensitization(4,14,18) }}
              el-form-item(label="营业执照")
                img(v-if="mchDetail.business_license_pic", :src="mchDetail.business_license_pic | image", @click="$zoom($options.filters.image(mchDetail.business_license_pic))").mch-image
                template(v-else) 未提交
            el-col(:span="12")
              el-form-item(label="结算方式") {{ mchDetail.settle_type | settle_type_long }}
              el-form-item(label="证件类型") {{ mchDetail.resp_per_id_type | resp_per_id_type }}
              el-form-item(label='') &nbsp;
              el-form-item(label="身份证照片")
                el-row(:gutter="10")
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_positive", :src="mchDetail.resp_per_id_positive | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_positive))").mch-image
                    template(v-else) 未提交
                  el-col(:span="10")
                    img(v-if="mchDetail.resp_per_id_opposite", :src="mchDetail.resp_per_id_opposite | image",
                        @click="$zoom($options.filters.image(mchDetail.resp_per_id_opposite))").mch-image
                    template(v-else) 未提交
          hr
          h4 个人联系方式
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="联系地址") {{ mchDetail.business_address || '未填写' }}
              el-form-item(label="手机",required) {{ mchDetail.resp_per_telephone_no || '未绑定' | desensitization}}
            el-col(:span="12")
              el-form-item(label="") &nbsp;
              el-form-item(label="") &nbsp;
              el-form-item(label="邮箱") {{ mchDetail.resp_per_email || '未绑定' }}

      .dialog-footer(slot="footer")
        el-button(@click="mchAuditDetail.show=false") 关闭

</template>

<script>
import { errorDictionaries } from "@/gadgets/dictionaries";
export default {
  data() {
    return {
      page: 1,
      size: 20,
      status: 0,
      list: [],
      total: 0,
      cd: 0,
      listLoading: false,

      filters: {
        account_id: null
      },
      hasFilter: false,

      createAccount: {
        show: false,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      },

      createWallet: {
        show: false,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      },

      bindWallet: {
        show: false,
        mobile: null,
        verify_code: null,
        loading: false,
        verify_locked: false
      },

      mchAuditDetail: {
        show: false,
        mch_draft: {}
      },
      wallet_tunnel: {},
      open_wallet: 3,
      wallet_url: null,
      wallet_id: "",
      signDisable: true,
      source: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        opt: 1
      },
      bankClassList: [],
      bankAreaList: [],
      bankList: [],
      uploadURL: "/mch_web/v1/upload_picture",
      mchDetail: {},
      settle_id: 1
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    mch_type() {
      return this.$store.getters.userInfo.mch_type;
    },
    settle_type() {
      return this.$store.getters.userInfo.settle_type;
    }
    // mchDetail() {
    //   return this.$store.getters.mchDetail;
    // }
  },
  filters: {
    type(source) {
      switch (source) {
        case 1:
          return "公司";
        case 2:
          return "个人";
        default:
          return source;
      }
    },

    settle_type(source) {
      switch (source) {
        case 1:
          return "银行账号";
        case 2:
          return "钱包账号";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return source;
      }
    },
    status(source) {
      switch (parseInt(source)) {
        case 1:
          return "启用";
        case 2:
          return "禁用";
        default:
          return source;
      }
    },
    bound_bank_card(source) {
      switch (parseInt(source)) {
        case 0:
          return "待绑卡";
        case 1:
          return "已绑卡";
        default:
          return source;
      }
    },
    open_wallet(source) {
      switch (parseInt(source)) {
        case 0:
          return "未绑定";
        case 1:
          return "已绑定";
        default:
          return source;
      }
    }
  },
  methods: {
    uploadChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 1 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = e => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);
          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.source, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`商家资料图片上传失败。${code}：${msg}`, {
                type: "error"
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过1MB。", {
          type: "error"
        });
      }
    },
    // 点击审批相关

    showMchDetail(mch_draft) {
      this.mchAuditDetail = {
        show: true,
        mch_draft: mch_draft
      };
    },
    showWalletOrMchDetail(tunnelStatus, wallet_tunnel, mch_draft) {
      if (tunnelStatus === 3) {
        this.showWalletDetail(wallet_tunnel)
      } else {
        this.showMchDetail(mch_draft)
      }
    },
    // 点击富力钱包
    showWalletDetail(wallet_tunnel) {
      // 企业的
      if (this.mchDetail.type === 1) {
        // 先查一下当前的钱包状态
        this.$store
          .dispatch("GET_WALLET_CHANNEL_INFO", wallet_tunnel.wallet_id)
          .then(res => {
            // 后台说明：
            // security_tel 为空  或 status为 3 就 验证码这个页面；
            // status为3 is_sign_contact 为空或者0就会员协议内嵌页 ；
            // status为3 is_sign_contact 为1 就扣款协议内嵌页；
            // status为3 is_sign_contact 为2 就最终成功开通页
            if (res.status === 3) {
              if (!res.security_tel) {
                this.$router.push(
                  `/wallet/reg-wallet-1/${wallet_tunnel.wallet_id}/${
                    wallet_tunnel.settle_id
                  }`
                );
              } else if (res.is_sign_contact === 0) {
                this.$router.push(
                  `/wallet/reg-wallet-2/${wallet_tunnel.wallet_id}/${
                    wallet_tunnel.settle_id
                  }`
                );
              } else if (res.is_sign_contact === 1) {
                this.$router.push(
                  `/wallet/reg-wallet-3/${wallet_tunnel.wallet_id}/${
                    wallet_tunnel.settle_id
                  }`
                );
              } else {
                this.$router.push(
                  `/wallet/detail/${wallet_tunnel.wallet_id}/${
                    wallet_tunnel.settle_id
                  }`
                );
              }
            } else {
              this.$message({
                type: "warning",
                message: `该钱包审核未通过或未审核`
              });
            }
          });
      } else {
        console.log('wallet_tunnel',wallet_tunnel)
        if (wallet_tunnel.wallet_id && wallet_tunnel.is_sign_contact === 1) {
          this.$router.push(
            `/wallet/reg-wallet-3/${wallet_tunnel.wallet_id}/${
              wallet_tunnel.settle_id
            }`
          );
        } else if (
          wallet_tunnel.wallet_id &&
          wallet_tunnel.is_sign_contact === 2
        ) {
          this.$router.push(
            `/wallet/detail/${wallet_tunnel.wallet_id}/${
              wallet_tunnel.settle_id
            }`
          );
        } else {
          this.showBindWallet();
        }
      }
    },
    showDetail(
      settle_type,
      settle_account,
      account_id,
      bind_status,
      settle_rela_id
    ) {
      console.log(
        settle_type,
        settle_account,
        account_id,
        bind_status,
        settle_rela_id
      );
      //   const id = settle_type === 3 ? account_id : bind_status === 1 ? settle_rela_id : settle_account;
      const id = settle_type === 3 ? account_id : settle_rela_id;
      this.$router.push(`/settle/${settle_type}/${id}`);
    },

    // 去签约
    goSign() {
      this.$router.push(
        `/wallet/reg-wallet-3/${this.wallet_id}/${this.settle_id}`
      );
    },

    copyAccountId(content) {
      this.$clipboard(content);
      this.$message({
        type: "success",
        message: "账户 ID 已复制"
      });
    },

    showCreate() {
      this.createAccount = {
        show: true,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      };

      this.getBankClassList().then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.createAccount.class_code = data[0].class_code;
          this.setBankClass();
        }
      });
      this.getMchDetail();
    },

    showCreateWallet() {
      this.createWallet = {
        show: true,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      };
      //   this.get;
      //   this.getBankClassList().then(data => {
      //     if (Array.isArray(data) && data.length > 0) {
      //       this.createWallet.class_code = data[0].class_code;
      //       this.setBankClass();
      //     }
      //   });
      this.getBankClassListWallet();
      this.getMchDetail();
    },
    hideCreate() {
      this.createAccount = {
        show: false,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      };
    },
    saveCreate() {
      if (!this.createAccount.source.bank_account) {
        this.$message({
          type: "warning",
          message: `请输入对公账户账号。`
        });
      }
      if (!this.createAccount.source.bank_code) {
        this.$message({
          type: "warning",
          message: `请选择开户支行。`
        });
      }

      this.$store
        .dispatch("CREATE_SETTLE_ACCOUNT", this.createAccount.source)
        .then(() => {
          this.hideCreate();
          this.getList(1);

          this.$message({
            type: "success",
            message: "结算账户添加成功。"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `结算账户添加失败。${code}：${msg}`
          });
        });
    },

    saveWalletCreate() {
      if (!this.source.deposit_bank) {
        this.$message({
          type: "warning",
          message: `请选择开户银行。`
        });
        return;
      }
      if (!this.source.deposit_bank_province) {
        this.$message({
          type: "warning",
          message: `请选择开户银行所在地。`
        });
        return;
      }
      if (!this.source.union_bank) {
        this.$message({
          type: "warning",
          message: `请选择支行名称。`
        });
        return;
      }
      if (!this.source.public_account) {
        this.$message({
          type: "warning",
          message: `请填写对公账号。`
        });
        return;
      }
      if (!this.source.public_account_pic) {
        this.$message({
          type: "warning",
          message: `请上传对公账户证明。`
        });
        return;
      }
      const params = {
        area_id: this.source.area_id,
        deposit_bank: this.source.deposit_bank,
        deposit_bank_city: this.source.deposit_bank_city,
        deposit_bank_id: this.source.deposit_bank_id,
        deposit_bank_province: this.source.deposit_bank_province,
        public_account: this.source.public_account,
        public_account_name: this.mchDetail.mch_name,
        public_account_pic: this.source.public_account_pic,
        sub_branch_bank: this.source.sub_branch_bank,
        union_bank: this.source.union_bank
      };
      this.$store
        .dispatch("ADD_WALLET", params)
        .then(() => {
          this.hideWalletCreate();
          this.getList(1);
          this.$message({
            type: "success",
            message:
              "提交信息成功，待运营审核通过后会在结算账户页面显示该钱包。"
          });
        })
        .catch(({ code, msg }) => {
          if (code === 1004) {
            const start = msg.indexOf("：");
            const key = msg.substring(start + 1);
            const errorMsg = errorDictionaries[key];
            this.$message({
              type: "error",
              message: `${errorMsg}输入有误，请检查后，重新输入`
            });
          } else {
            this.$message({
              type: "error",
              message: `新增钱包失败。${code}：${msg}`
            });
          }
        });
    },

    hideWalletCreate() {
      this.createWallet = {
        show: false,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      };
      this.source = {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        opt: 1,
        hasWallet: false
      };
    },

    setBankClass() {
      this.getBankAreaList().then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.createAccount.area_code = data[0].area_code;
          this.setBankArea();
        } else {
          this.createAccount.area_code = null;
        }
      });
    },
    setBankArea() {
      this.getBankList().then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.createAccount.source.bank_code = data[0].bank_code;
        } else {
          this.createAccount.source.bank_code = null;
        }
      });
    },

    getBankClassList() {
      return this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then(data => {
          this.createAccount.bankClassList = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`
          });
        });
    },
    getBankAreaList() {
      return this.$store
        .dispatch("GET_BANK_AREA_LIST", this.createAccount.class_code)
        .then(data => {
          this.createAccount.bankAreaList = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行地区列表失败。${code}：${msg}`
          });
        });
    },
    getBankList() {
      const params = {
        class_code: this.createAccount.class_code,
        area_code: this.createAccount.area_code
      };
      return this.$store
        .dispatch("GET_BANK_LIST", params)
        .then(data => {
          this.createAccount.bankList = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$toast({
            message: `获取支行列表失败。${code}：${msg}`,
            duration: 3000
          });
        });
    },
    getMchDetail() {
      this.loading = true;
      const { uname } = this.userInfo;
      return this.$store
        .dispatch("GET_MCH_DETAIL", uname)
        .then(data => {
          this.createAccount.mch_name = data.mch_name;
          this.mchDetail = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$alert(`商家资料获取失败。${code}：${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    showBindWallet() {
      this.bindWallet = {
        show: true,
        mobile: null,
        verify_code: null,

        loading: false,
        verify_locked: false
      };
      const lastSendSMSTime = localStorage.getItem("lastSendSMSTime_wallet");
      if (parseInt(lastSendSMSTime) > +new Date() - 60 * 1000) {
        this.bindWallet.mobile = localStorage.getItem("mobile_wallet");
      }

      if (!this.wallet_url) {
        this.getWalletURL();
      }
    },
    hideBindWallet() {
      this.bindWallet = {
        show: false,
        mobile: null,
        verify_code: null,

        loading: false,
        verify_locked: false
      };
    },
    sendVerifySMS() {
      const lastSendSMSTime = localStorage.getItem("lastSendSMSTime_wallet");
      if (
        !lastSendSMSTime ||
        parseInt(lastSendSMSTime) < +new Date() - 60 * 1000
      ) {
        const mobile = this.bindWallet.mobile;

        if (!mobile || !this.$regex.phoneRegex.test(mobile)) {
          this.$message({
            type: "warning",
            message: `请输入有效的手机号码`
          });
          return;
        }
        if (this.bindWallet.verify_locked) {
          this.$message({
            type: "warning",
            message: `两次获取验证码间隔不能小于60秒`
          });
          return;
        }
        localStorage.setItem("mobile_wallet", mobile);
        localStorage.setItem("lastSendSMSTime_wallet", +new Date());
        this.cd = 60;
        this.startCountdown();
        this.bindWallet.loading = true;
        window
          .getWMToken()
          .then(verify_token => {
            this.$store
              .dispatch("SEND_WALLET_VERIFY_CODE", {
                mobile,
                verify_token,
                type: 2,
                redirect_url: `${window.location.origin}${
                  window.location.pathname
                }${window.location.hash}`
              })
              .then(({ captcha_url }) => {
                if (captcha_url) {
                  //   this.isOpenCapurl = true;
                  localStorage.setItem("bindWalleting", 1);
                  window.location.replace(captcha_url);
                } else {
                  this.bindWallet.verify_locked = true;
                  this.$message({
                    type: "success",
                    message: `验证码已发出，请注意查收`
                  });
                }
              })
              .catch(({ code, msg, originData }) => {
                if (code === 54001 || code === 2033) {
                  localStorage.setItem("bindWalleting", 1);
                  window.location.replace(originData.captcha_url);
                } else {
                  this.$message({
                    type: "error",
                    message: `${code}: ${msg}`
                  });
                }
              })
              .finally(() => {
                this.bindWallet.loading = false;
              });
          })
          .catch(error => {
            this.$message({
              type: "error",
              message: `${error}`
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: `两次获取验证码间隔不能小于60秒`
        });
      }
    },
    saveBindWallet() {
      const mobile = this.bindWallet.mobile;
      if (!mobile || !this.$regex.phoneRegex.test(mobile)) {
        this.$message({
          type: "warning",
          message: `请输入有效的手机号码`
        });
        return;
      }
      if (!this.bindWallet.verify_code) {
        this.$message({
          type: "warning",
          message: `请输入验证码`
        });
        return;
      }

      this.bindWallet.loading = true;
      this.$store
        .dispatch("BIND_WALLET_WITH_VERIFY_CODE", this.bindWallet)
        .then(data => {
          //   this.hideBindWallet();
          this.getList(1);
          this.signDisable = false;
          this.wallet_id = data;
          this.$message({
            type: "success",
            message: "富力钱包绑定成功。"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `富力钱包绑定失败。${code}：${msg}`
          });
        })
        .finally(() => {
          this.bindWallet.loading = false;
        });
    },
    getWalletURL() {
      if (this.bindWallet.show) {
        this.bindWallet.loading = true;
      }
      return this.$store
        .dispatch("GET_WALLET_URL")
        .then(({ wallet_base_url }) => {
          this.wallet_url = wallet_base_url;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取富力钱包页面地址失败。${code}：${msg}`
          });
        })
        .finally(() => {
          if (this.bindWallet.show) {
            this.bindWallet.loading = false;
          }
        });
    },

    setFilter() {
      if (this.filters.account_id) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.getList(1);
    },
    clearFilter() {
      this.filters = {
        account_id: null
      };
      this.hasFilter = false;
      this.getList(1);
    },
    refresh() {
      this.getList(this.page);
    },
    changeListSize(size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList(page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters);
      this.$store
        .dispatch(
          "GET_SETTLE_ACCOUNT_LIST",
          Object.assign(
            {
              offset: this.size * (this.page - 1),
              limit: this.size,
              stat: true
            },
            _filters
          )
        )
        .then(data => {
          //   this.open_wallet = open_wallet;
          this.list = data.list
          // console.log(this.list);

          data.list.forEach(element => {
            if (element.settle_type === 3) {
              this.hasWallet = true;
            }
          });
          this.total = data.total;
          this.listLoading = false;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 获取开户银行
    getBankClassListWallet() {
      this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then(data => {
          this.bankClassList = data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`
          });
        });
    },

    // 获取开户银行区域
    getBankAreaListWallet() {
      return new Promise((resolve, reject) => {
        if (this.source.bankClass.class_code) {
          this.source.deposit_bank = this.source.bankClass.class_name;
          this.source.deposit_bank_id = this.source.bankClass.class_code;
          this.$store
            .dispatch("GET_BANK_AREA_LIST", this.source.bankClass.class_code)
            .then(data => {
              this.bankAreaList = data;
              this.source.bankArea = {};
              this.source.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取银行地区列表失败。${code}：${msg}`
              });
              resolve();
            });
        } else {
          this.source.bankArea = {};
          this.source.bank = {};
          this.source.area_id = null;
          this.source.deposit_bank_id = null;
          this.source.deposit_bank = null;
          this.source.deposit_bank_city = null;
          this.source.sub_branch_bank = null;
          this.source.union_bank = null;
          resolve();
        }
      });
    },

    // 获取支行
    getBankListWallet() {
      return new Promise((resolve, reject) => {
        if (this.source.bankClass.class_code && this.source.bankArea) {
          this.source.bankArea = this.source.bankArea;
          this.source.deposit_bank_province = this.source.bankArea.province_name;
          this.source.deposit_bank_city = this.source.bankArea.city_name;
          this.source.area_id = this.source.bankArea.area_code;
          const params = {
            class_code: this.source.bankClass.class_code,
            area_code: this.source.bankArea.area_code
          };
          this.$store
            .dispatch("GET_BANK_LIST", params)
            .then(data => {
              this.bankList = data;
              this.source.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取支行列表失败。${code}：${msg}`
              });
              resolve();
            });
        } else {
          this.source.bank = {};
          this.source.deposit_bank = null;
          this.source.deposit_bank_city = null;
          this.source.sub_branch_bank = null;
          this.source.union_bank = null;
          resolve();
        }
      });
    },

    // 获取最后的支行
    getBankWallet() {
      if (this.source.bank) {
        this.source.sub_branch_bank = this.source.bank.bank_name;
        this.source.union_bank = this.source.bank.bank_code;
      } else {
        this.source.sub_branch_bank = null;
        this.source.union_bank = null;
      }
    },

    startCountdown() {
      const t = setInterval(() => {
        if (this.cd > 0) {
          this.cd--;
        } else {
          this.cd = 0;
          this.bindWallet.verify_locked = false;
          clearInterval(t);
        }
      }, 1000);
    }
  },
  async mounted() {
    this.getList(1);
    this.getMchDetail();
    const lastSendSMSTime = localStorage.getItem("lastSendSMSTime_wallet");
    if (parseInt(lastSendSMSTime) > +new Date() - 60 * 1000) {
      this.cd = Math.floor(
        (parseInt(lastSendSMSTime) - (+new Date() - 60 * 1000)) / 1000
      );
      this.bindWallet.mobile = localStorage.getItem("mobile_wallet");
      this.startCountdown();
    }
    if (localStorage.getItem("bindWalleting") == 1) {
      await this.getWalletURL();
      // todo 先拿到二维码地址
      this.bindWallet.show = true;
      localStorage.setItem("bindWalleting", 0);
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-settle-list {
  .settle-card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .settle-card {
    box-sizing: border-box;
    width: 23%;
    margin: 10px 1%;

    .el-card__header {
      padding: 10px;
      font-size: 14px;
      font-weight: bold;
      word-break: break-all;
      background: rgba(38, 90, 160, 1);
      color: #fff;
    }
    .el-card__body {
      padding: 10px;
      font-size: 12px;
    }
  }

  .settle-card-options {
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg + span,
    span + svg {
      margin-left: 0.5em;
    }
  }
  .settle-card-copy,
  .settle-card-detail {
    cursor: pointer;
  }
  .wallet-step-title {
    font-weight: 550;
    font-size: 16px;
    margin-bottom: 8px;
  }
  .login-success {
    width: 36rem;
    height: 5rem;
    border: 1px solid blue;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-circle-check {
      font-size: 24px;
      color: green;
      margin-right: 8px;
    }
    span {
      font-size: 22px;
    }
  }
}
.sms .el-input-group__append {
  background: #275aa0;
  color: #fff;
}
</style>
